// import { useState, useEffect } from "react";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import { getLeadFunnelByDateRange } from "../ActionCreator";
// import SpinnerLoader from "../../../../presentationals/Loader/Loader.component";
// import moment from "moment";
// import DateFilterSelect from "../../../../CustomDatePicker/DateFilterSelect";

// export default function LeadConversionStat({
//   dateFilterPopup,
//   handleDateFilterPopup,
//   dateType,
//   setDateType,
//   updateDateRange
// }) {
//   const [data, setData] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [isFilterCleared, setIsFilterCleared] = useState(false);

//   // const [date, setDate] = useState({
//   //   from: moment(new Date()).format("YYYY-MM-DD"),
//   //   to: moment(new Date()).format("YYYY-MM-DD"),
//   // });

//   // const handleDateChange = (type, value) => {
//   //   setDate((prev) => ({
//   //     ...prev,
//   //     [type === "start" ? "from" : "to"]: value,
//   //   }));
//   // };

//   const fetchData = (customDate) => {
//     const sDate = moment(customDate?.from).format("DD-MM-YYYY");
//     const eDate = moment(customDate?.to).format("DD-MM-YYYY");
//     setIsLoading(true);
//     getLeadFunnelByDateRange(sDate, eDate, (res) => {
//       setIsLoading(false);
//       setData(res?.data?.data || {});
//     });
//   };

//   useEffect(() => {
//     fetchData(dateFilterPopup);
//   }, [dateFilterPopup?.from, dateFilterPopup?.to]);

//   const formatTime = (ms) => {
//     if (!ms || ms <= 0) return "-";

//     const totalSeconds = Math.floor(ms / 1000);

//     const days = Math.floor(totalSeconds / 86400);
//     const hours = Math.floor((totalSeconds % 86400) / 3600);
//     const minutes = Math.floor((totalSeconds % 3600) / 60);
//     const seconds = totalSeconds % 60;

//     if (days > 0) return `${days}d ${hours}h`;
//     if (hours > 0) return `${hours}h ${minutes}m`;
//     if (minutes > 0) return `${minutes}m ${seconds}s`;

//     return `${seconds}s`;
//   };

//   const VerticalConnector = ({ height = "40px" }) => (
//     <div className="row" style={{ display: "flex", justifyContent: "center" }}>
//       <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//         <div
//           style={{
//             position: "relative",
//             height: height,
//             display: "flex",
//             justifyContent: "center",
//           }}
//         >
//           <div
//             style={{
//               width: "3px",
//               height: "100%",
//               backgroundColor: "rgba(100, 116, 139, 0.4)",
//             }}
//           ></div>
//           <div
//             style={{
//               position: "absolute",
//               bottom: "-11px",
//               left: "50%",
//               transform: "translateX(-50%)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <KeyboardArrowDownIcon
//               style={{
//                 color: "rgba(100, 116, 139, 0.6)",
//                 fontSize: "24px",
//                 display: "block",
//               }}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const SplitConnector = () => (
//     <div
//       className="row"
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         position: "relative",
//         margin: "0",
//       }}
//     >
//       <div className="col-lg-9 col-md-11 col-sm-12">
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             position: "relative",
//             height: "60px",
//             padding: "0 20px",
//           }}
//         >
//           {/* Main vertical line from top */}
//           <div
//             style={{
//               position: "absolute",
//               left: "50%",
//               top: "0",
//               width: "3px",
//               height: "25px",
//               backgroundColor: "rgba(100, 116, 139, 0.4)",
//               transform: "translateX(-50%)",
//             }}
//           ></div>

//           {/* Horizontal line connecting all three paths */}
//           <div
//             style={{
//               position: "absolute",
//               top: "25px",
//               left: "15%",
//               right: "15%",
//               borderTop: "3px solid rgba(100, 116, 139, 0.4)",
//               height: "3px",
//             }}
//           ></div>

//           {/* Three vertical drops with arrows - LEFT */}
//           <div
//             style={{
//               position: "absolute",
//               left: "15%",
//               top: "25px",
//               width: "3px",
//               height: "35px",
//               backgroundColor: "rgba(100, 116, 139, 0.4)",
//               transform: "translateX(-50%)",
//             }}
//           >
//             <div
//               style={{
//                 position: "absolute",
//                 bottom: "-11px",
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <KeyboardArrowDownIcon
//                 style={{
//                   color: "rgba(100, 116, 139, 0.6)",
//                   fontSize: "24px",
//                   display: "block",
//                 }}
//               />
//             </div>
//           </div>

//           {/* CENTER */}
//           <div
//             style={{
//               position: "absolute",
//               left: "50%",
//               top: "25px",
//               width: "3px",
//               height: "35px",
//               backgroundColor: "rgba(100, 116, 139, 0.4)",
//               transform: "translateX(-50%)",
//             }}
//           >
//             <div
//               style={{
//                 position: "absolute",
//                 bottom: "-11px",
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <KeyboardArrowDownIcon
//                 style={{
//                   color: "rgba(100, 116, 139, 0.6)",
//                   fontSize: "24px",
//                   display: "block",
//                 }}
//               />
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div
//             style={{
//               position: "absolute",
//               right: "15%",
//               top: "25px",
//               width: "3px",
//               height: "35px",
//               backgroundColor: "rgba(100, 116, 139, 0.4)",
//               transform: "translateX(50%)",
//             }}
//           >
//             <div
//               style={{
//                 position: "absolute",
//                 bottom: "-11px",
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <KeyboardArrowDownIcon
//                 style={{
//                   color: "rgba(100, 116, 139, 0.6)",
//                   fontSize: "24px",
//                   display: "block",
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const MergeConnector = () => (
//     <div
//       className="row"
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         position: "relative",
//         margin: "0",
//       }}
//     >
//       <div className="col-lg-9 col-md-11 col-sm-12">
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             position: "relative",
//             height: "60px",
//             padding: "0 20px",
//           }}
//         >
//           {/* Three vertical lines going up */}
//           <div
//             style={{
//               position: "absolute",
//               left: "15%",
//               top: "0",
//               width: "3px",
//               height: "25px",
//               backgroundColor: "rgba(100, 116, 139, 0.4)",
//               transform: "translateX(-50%)",
//             }}
//           ></div>

//           <div
//             style={{
//               position: "absolute",
//               left: "50%",
//               top: "0",
//               width: "3px",
//               height: "25px",
//               backgroundColor: "rgba(100, 116, 139, 0.4)",
//               transform: "translateX(-50%)",
//             }}
//           ></div>

//           <div
//             style={{
//               position: "absolute",
//               right: "15%",
//               top: "0",
//               width: "3px",
//               height: "25px",
//               backgroundColor: "rgba(100, 116, 139, 0.4)",
//               transform: "translateX(50%)",
//             }}
//           ></div>

//           {/* Horizontal line connecting all three */}
//           <div
//             style={{
//               position: "absolute",
//               top: "25px",
//               left: "15%",
//               right: "15%",
//               borderTop: "3px solid rgba(100, 116, 139, 0.4)",
//               height: "3px",
//             }}
//           ></div>

//           {/* Single line going down to center */}
//           <div
//             style={{
//               position: "absolute",
//               left: "50%",
//               top: "25px",
//               width: "3px",
//               height: "35px",
//               backgroundColor: "rgba(100, 116, 139, 0.4)",
//               transform: "translateX(-50%)",
//             }}
//           >
//             <div
//               style={{
//                 position: "absolute",
//                 bottom: "-11px",
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <KeyboardArrowDownIcon
//                 style={{
//                   color: "rgba(100, 116, 139, 0.6)",
//                   fontSize: "24px",
//                   display: "block",
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // const handleFilterApply = () => {
//   //   fetchData(dateFilterPopup);
//   // };

//   const handleFilterReset = () => {
//     const from = moment().subtract(6, "days").format("YYYY-MM-DD");
//     const to = moment().format("YYYY-MM-DD");
//     setIsFilterCleared(true)

//     handleDateFilterPopup("from", from);
//     handleDateFilterPopup("to", to);
//     fetchData({ from, to });
//   };

//   // const handleDateFilterPopup = (type, val) => {
//   //   setDate((prev) => ({ ...prev, [type]: val }));
//   // };

//   return (
//     <>
//       <div
//         className="HeadingFilter-main-filters"
//         style={{
//           marginTop: "10px",
//           padding: window.innerWidth >= 1800 ? "10px" : "2px 10px 6px 10px",
//         }}
//       >
//         <div className="row">
//           <div
//             className="col-xl-9 col-lg-10 col-xs-12"
//             style={{ display: "flex", gap: "10px", marginTop: "5px" }}
//           >
//             <DateFilterSelect
//             dateFilterPopup={dateFilterPopup}
//                                                                                    onChange={(range) => {
//     updateDateRange(range[0], range[1], "custom");
//   }}
//               isFilterCleared={isFilterCleared}
//               type={dateType}
//               onTypeChange={setDateType}
//             />
//           </div>
//           <div
//             className="col-xl-3 col-lg-2 col-xs-12"
//             style={{ marginTop: "5px" }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 gap: "8px",
//                 justifyContent: window.innerWidth > 1200 ? "end" : "start",
//               }}
//             >
//               {/* <div className="custom-btn" onClick={handleFilterApply}>
//                 <i className="fa fa-filter" aria-hidden="true"></i>
//               </div> */}
//               <div className="custom-btn">
//                 <i className="fa fa-download" aria-hidden="true"></i>
//               </div>
//               <div className="custom-btn" onClick={handleFilterReset}>
//                 <i className="fa fa-times" aria-hidden="true"></i>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {isLoading ? (
//         <SpinnerLoader />
//       ) : (
//         <div className="customTree" style={{ padding: "20px 0" }}>
//           {/* 1. PENDING LEAD */}
//           <div
//             className="row"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               marginTop: "20px",
//             }}
//           >
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard firstOne">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>Pending Lead</h5>
//                   <h4>{data?.pending?.count}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{formatTime(data?.pending?.avgTatMs)}</h4>
//                   <h6>Avg TAT</h6> */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <VerticalConnector />

//           {/* 2. NEW LEAD */}
//           <div
//             className="row"
//             style={{ display: "flex", justifyContent: "center" }}
//           >
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard secondOne yellowish">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>New Lead</h5>
//                   <h4>{data?.newlead?.count}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{formatTime(data?.newlead?.avgTatMs)}</h4>
//                   <h5>Avg TAT</h5> */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <VerticalConnector />

//           {/* 3. COMMUNICATED */}
//           <div
//             className="row"
//             style={{ display: "flex", justifyContent: "center" }}
//           >
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard secondOne bluish">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>Communicated</h5>
//                   <h4>{data?.communicated?.count}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{formatTime(data?.communicated?.avgTatMs)}</h4>
//                   <h5>Avg TAT</h5> */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <VerticalConnector />

//           {/* 4. MARK AS COMPLETE */}
//           <div
//             className="row"
//             style={{ display: "flex", justifyContent: "center" }}
//           >
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard secondOne bluish">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>Mark as Complete</h5>
//                   <h4>{data?.markAsCompleteCount}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{"-"}</h4>
//                   <h5>Avg TAT</h5> */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <VerticalConnector />

//           {/* 5. LOAN UNDER PROCESS */}
//           <div
//             className="row"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               background: "rgba(214, 215, 255, 0.38)",
//               padding: "30px 0 20px 0",
//               position: "relative",
//               margin: "0",
//             }}
//           >
//             <div className="customSection-tag-box">
//               <h5 style={{ color: "rgba(116, 82, 157, 1)" }}>
//                 FIRST‑LEVEL FILTER (POST COMMUNICATION)
//               </h5>
//             </div>
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard secondOne bluish">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>Loan Under Process</h5>
//                   <h4>{data?.loanunderprocess?.count}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{formatTime(data?.loanunderprocess?.avgTatMs)}</h4>
//                   <h5>Avg TAT</h5> */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <SplitConnector />

//           {/* 6. APPROVED | REJECTED | EXPIRED */}
//           <div
//             className="row"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               gap: "3%",
//               background: "rgba(220, 159, 255, 0.08)",
//               padding: "20px 0 30px 0",
//               position: "relative",
//               margin: "0",
//             }}
//           >
//             <div className="customSection-tag-box">
//               <h5 style={{ color: "rgba(138, 42, 143, 1)" }}>
//                 SECOND‑LEVEL FILTER (POST LUP)
//               </h5>
//             </div>
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard secondOne bluish">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>Approved</h5>
//                   <h4>{data?.approved?.count}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{formatTime(data?.approved?.avgTatMs)}</h4>
//                   <h5>Avg TAT</h5> */}
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard secondOne redish">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>Rejected</h5>
//                   <h4>{data?.rejected?.count}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{formatTime(data?.rejected?.avgTatMs)}</h4>
//                   <h5>Avg TAT</h5> */}
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard secondOne orangish">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>Expired</h5>
//                   <h4>{data?.expired?.count}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{formatTime(data?.expired?.avgTatMs)}</h4>
//                   <h5>Avg TAT</h5> */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Connecting line - from Approved only to RFD/PFD */}
//           <div
//             className="row"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               position: "relative",
//               margin: "0",
//             }}
//           >
//             <div className="col-lg-9 col-md-11 col-sm-12">
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "flex-start",
//                   position: "relative",
//                   height: "60px",
//                   padding: "0 20px",
//                 }}
//               >
//                 {/* Single vertical line from Approved (left position at 15%) */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     left: "15%",
//                     top: "0",
//                     width: "3px",
//                     height: "30px",
//                     backgroundColor: "rgba(100, 116, 139, 0.4)",
//                     transform: "translateX(-50%)",
//                   }}
//                 ></div>

//                 {/* Horizontal line going to center */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "30px",
//                     left: "15%",
//                     width: "35%",
//                     borderTop: "3px solid rgba(100, 116, 139, 0.4)",
//                     height: "3px",
//                   }}
//                 ></div>

//                 {/* Vertical line down to center */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     left: "50%",
//                     top: "30px",
//                     width: "3px",
//                     height: "30px",
//                     backgroundColor: "rgba(100, 116, 139, 0.4)",
//                     transform: "translateX(-50%)",
//                   }}
//                 >
//                   <div
//                     style={{
//                       position: "absolute",
//                       bottom: "-11px",
//                       left: "50%",
//                       transform: "translateX(-50%)",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <KeyboardArrowDownIcon
//                       style={{
//                         color: "rgba(100, 116, 139, 0.6)",
//                         fontSize: "24px",
//                         display: "block",
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* 7. RFD/PFD */}
//           <div
//             className="row"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               background: "rgba(52, 170, 56, 0.08)",
//               padding: "20px 0 30px 0",
//               position: "relative",
//               margin: "0",
//             }}
//           >
//             <div className="customSection-tag-box">
//               <h5 style={{ color: "rgba(50, 126, 69, 1)" }}>
//                 POST‑APPROVAL (OPS STAGE)
//               </h5>
//             </div>
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard secondOne bluish">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>RFD/PFD</h5>
//                   <h4>{data?.rfdCount}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{"-"}</h4>
//                   <h5>Avg TAT</h5> */}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <VerticalConnector />

//           {/* 8. DISBURSED */}
//           <div
//             className="row"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               marginBottom: "30px",
//             }}
//           >
//             <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12">
//               <div className="customCard thirdOne">
//                 <div style={{ textAlign: "center" }}>
//                   <h5>Disbursed</h5>
//                   <h4>{data?.disbursed?.count}</h4>
//                   {/* <div className="liness"></div>
//                   <h4>{formatTime(data?.disbursed?.avgTatMs)}</h4>
//                   <h5>Avg TAT</h5> */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }



// import { useState, useEffect } from "react";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import { getLeadFunnelByDateRange } from "../ActionCreator";
// import SpinnerLoader from "../../../../presentationals/Loader/Loader.component";
// import moment from "moment";
// import DateFilterSelect from "../../../../CustomDatePicker/DateFilterSelect";

// // ─── DropOffSideCard ──────────────────────────────────────────────────────────

// const DropOffSideCard = ({ label, count, percentage }) => {
//   if (!count || count <= 0) return <div style={{ minWidth: "210px" }} />;
//   return (
//     <div style={{ display: "flex", alignItems: "center" }}>
//       {/* Arrow connector */}
//       <div
//         style={{
//           position: "relative",
//           width: "50px",
//           height: "3px",
//           backgroundColor: "rgba(239,68,68,0.35)",
//         }}
//       >
//         <div
//           style={{
//             position: "absolute",
//             right: "0px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             borderTop: "5px solid transparent",
//             borderBottom: "5px solid transparent",
//             borderLeft: "7px solid rgba(239,68,68,0.5)",
//           }}
//         />
//       </div>

//       {/* Card */}
//       <div
//         style={{
//           border: "1.5px solid rgba(239,68,68,0.3)",
//           borderRadius: "10px",
//           padding: "20px",
//           backgroundColor: "rgba(255,241,241,0.9)",
//           minWidth: "210px",
//           textAlign: "center",
//           boxShadow: "0 2px 8px rgba(239,68,68,0.08)",
//         }}
//       >
//         <h5
//           style={{
//             margin: "5px 0px",
//             fontSize: "10px",
//             fontWeight: 700,
//             color: "rgba(185,28,28,0.75)",
//             letterSpacing: "0.5px",
//             textTransform: "uppercase",
//           }}
//         >
//           {label}
//         </h5>
//         <h4
//           style={{
//             margin: "0 0 3px",
//             fontSize: "16px",
//             fontWeight: 500,
//             color: "rgba(185,28,28,1)",
//           }}
//         >
//           {count?.toLocaleString()}
//         </h4>
//         <span
//           style={{
//             fontSize: "11px",
//             color: "rgba(185,28,28,0.65)",
//             fontWeight: 500,
//           }}
//         >
//           {percentage}% drop-off
//         </span>
//       </div>
//     </div>
//   );
// };

// // ─── FunnelRow ────────────────────────────────────────────────────────────────
// // Keeps main card centered by mirroring drop-off card width on the left spacer.

// const FunnelRow = ({
//   children,
//   dropOffLabel,
//   dropOffCount,
//   dropOffPercentage,
//   style = {},
// }) => {
//   const hasDropOff = dropOffCount > 0;
//   const SIDE_WIDTH = 210;

//   return (
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         ...style,
//       }}
//     >
//       <div style={{ width: SIDE_WIDTH, flexShrink: 0, visibility: "hidden" }} />
//       <div style={{ flexShrink: 0 }}>{children}</div>
//       <div
//         style={{
//           width: SIDE_WIDTH,
//           flexShrink: 0,
//           display: "flex",
//           justifyContent: "flex-start",
//         }}
//       >
//         {hasDropOff && (
//           <DropOffSideCard
//             label={dropOffLabel}
//             count={dropOffCount}
//             percentage={dropOffPercentage}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// // ─── Connectors ───────────────────────────────────────────────────────────────

// const VerticalConnector = ({ height = "44px" }) => (
//   <div style={{ display: "flex", justifyContent: "center" }}>
//     <div
//       style={{
//         position: "relative",
//         height,
//         width: "3px",
//         backgroundColor: "rgba(100,116,139,0.35)",
//       }}
//     >
//       <KeyboardArrowDownIcon
//         style={{
//           position: "absolute",
//           bottom: "-13px",
//           left: "50%",
//           transform: "translateX(-50%)",
//           color: "rgba(100,116,139,0.55)",
//           fontSize: "24px",
//         }}
//       />
//     </div>
//   </div>
// );

// // 1→3 split: one line splits into three drops
// const SplitConnector = ({ leftPct = "22%", rightPct = "78%" }) => (
//   <div style={{ display: "flex", justifyContent: "center" }}>
//     <div style={{ position: "relative", height: "60px", width: "660px" }}>
//       {/* Stem down from parent */}
//       <div
//         style={{
//           position: "absolute",
//           left: "50%",
//           top: 0,
//           transform: "translateX(-50%)",
//           width: "3px",
//           height: "25px",
//           backgroundColor: "rgba(100,116,139,0.35)",
//         }}
//       />
//       {/* Horizontal bar */}
//       <div
//         style={{
//           position: "absolute",
//           top: "25px",
//           left: leftPct,
//           right: `calc(100% - ${rightPct})`,
//           height: "3px",
//           backgroundColor: "rgba(100,116,139,0.35)",
//         }}
//       />
//       {/* Three drops */}
//       {[leftPct, "50%", rightPct].map((pos, i) => (
//         <div
//           key={i}
//           style={{
//             position: "absolute",
//             left: pos,
//             top: "25px",
//             transform: "translateX(-50%)",
//             width: "3px",
//             height: "35px",
//             backgroundColor: "rgba(100,116,139,0.35)",
//           }}
//         >
//           <KeyboardArrowDownIcon
//             style={{
//               position: "absolute",
//               bottom: "-13px",
//               left: "50%",
//               transform: "translateX(-50%)",
//               color: "rgba(100,116,139,0.55)",
//               fontSize: "24px",
//             }}
//           />
//         </div>
//       ))}
//     </div>
//   </div>
// );

// // Approved only → center merge down to Disbursed
// const ApprovedToDisbursedConnector = ({ leftPct = "22%" }) => (
//   <div style={{ display: "flex", justifyContent: "center" }}>
//     <div style={{ position: "relative", height: "60px", width: "660px" }}>
//       <div
//         style={{
//           position: "absolute",
//           left: leftPct,
//           top: 0,
//           transform: "translateX(-50%)",
//           width: "3px",
//           height: "30px",
//           backgroundColor: "rgba(100,116,139,0.35)",
//         }}
//       />
//       <div
//         style={{
//           position: "absolute",
//           top: "30px",
//           left: leftPct,
//           width: `calc(50% - ${leftPct})`,
//           height: "3px",
//           backgroundColor: "rgba(100,116,139,0.35)",
//         }}
//       />
//       <div
//         style={{
//           position: "absolute",
//           left: "50%",
//           top: "30px",
//           transform: "translateX(-50%)",
//           width: "3px",
//           height: "30px",
//           backgroundColor: "rgba(100,116,139,0.35)",
//         }}
//       >
//         <KeyboardArrowDownIcon
//           style={{
//             position: "absolute",
//             bottom: "-13px",
//             left: "50%",
//             transform: "translateX(-50%)",
//             color: "rgba(100,116,139,0.55)",
//             fontSize: "24px",
//           }}
//         />
//       </div>
//     </div>
//   </div>
// );

// // ─── Section wrapper ──────────────────────────────────────────────────────────

// const Section = ({ label, labelColor, bg, children, style = {} }) => (
//   <div
//     style={{
//       background: bg,
//       padding: "28px 0 24px",
//       margin: 0,
//       position: "relative",
//       ...style,
//     }}
//   >
//     {label && (
//       <div className="customSection-tag-box">
//         <h5 style={{ color: labelColor, margin: 0 }}>{label}</h5>
//       </div>
//     )}
//     {children}
//   </div>
// );

// // ─── Main ─────────────────────────────────────────────────────────────────────

// export default function LeadConversionStat({
//   dateFilterPopup,
//   handleDateFilterPopup,
//   dateType,
//   setDateType,
//   updateDateRange,
// }) {
//   const [data, setData] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [isFilterCleared, setIsFilterCleared] = useState(false);

//   const fetchData = (range) => {
//     const sDate = moment(range?.from).format("DD-MM-YYYY");
//     const eDate = moment(range?.to).format("DD-MM-YYYY");
//     setIsLoading(true);
//     getLeadFunnelByDateRange(sDate, eDate, (res) => {
//       setIsLoading(false);
//       setData(res?.data?.data || {});
//     });
//   };

//   useEffect(() => {
//     fetchData(dateFilterPopup);
//   }, [dateFilterPopup?.from, dateFilterPopup?.to]);

//   const handleFilterReset = () => {
//     const from = moment().subtract(6, "days").format("YYYY-MM-DD");
//     const to = moment().format("YYYY-MM-DD");
//     setIsFilterCleared(true);
//     handleDateFilterPopup("from", from);
//     handleDateFilterPopup("to", to);
//     fetchData({ from, to });
//   };

//   // Derive drop-off data directly from API keys — no assumptions
//   const dropOff = {
//     pending: {
//       count: data?.pending?.rejectedAfterStage,
//       pct: data?.pending?.dropOffPercentage,
//     },
//     newlead: {
//       count: data?.newlead?.rejectedAfterStage,
//       pct: data?.newlead?.dropOffPercentage,
//     },
//     communicated: {
//       count: data?.communicated?.rejectedAfterStage,
//       pct: data?.communicated?.dropOffPercentage,
//     },
//     loanunderprocess: {
//       count: data?.loanunderprocess?.rejectedAfterStage,
//       pct: data?.loanunderprocess?.dropOffPercentage,
//     },
//   };

//   return (
//     <>
//       {/* ── Filter bar ── */}
//       <div
//         className="HeadingFilter-main-filters"
//         style={{ marginTop: 10, padding: "2px 10px 6px" }}
//       >
//         <div className="row">
//           <div
//             className="col-xl-9 col-lg-10 col-xs-12"
//             style={{ display: "flex", gap: 10, marginTop: 5 }}
//           >
//             <DateFilterSelect
//               dateFilterPopup={dateFilterPopup}
//               onChange={(range) =>
//                 updateDateRange(range[0], range[1], "custom")
//               }
//               isFilterCleared={isFilterCleared}
//               type={dateType}
//               onTypeChange={setDateType}
//             />
//           </div>
//           <div className="col-xl-3 col-lg-2 col-xs-12" style={{ marginTop: 5 }}>
//             <div
//               style={{
//                 display: "flex",
//                 gap: 8,
//                 justifyContent:
//                   window.innerWidth > 1200 ? "flex-end" : "flex-start",
//               }}
//             >
//               <div className="custom-btn">
//                 <i className="fa fa-download" />
//               </div>
//               <div className="custom-btn" onClick={handleFilterReset}>
//                 <i className="fa fa-times" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {isLoading ? (
//         <SpinnerLoader />
//       ) : (
//         <div className="customTree" style={{ padding: "20px 0" }}>
//           {/* 1 ── Pending Lead */}
//           <FunnelRow
//           // dropOffLabel="DROPPED AFTER PENDING"
//           // dropOffCount={dropOff.pending.count}
//           // dropOffPercentage={dropOff.pending.pct}
//           // style={{ marginTop: 20 }}
//           >
//             <div
//               className="customCard firstOne"
//               style={{ minWidth: 220, textAlign: "center" }}
//             >
//               <h5>Pending Lead</h5>
//               <h4>{data?.pending?.count?.toLocaleString()}</h4>
//             </div>
//           </FunnelRow>

//           <VerticalConnector />

//           {/* 2 ── New Lead */}
//           <FunnelRow
//             dropOffLabel="Rejected"
//             dropOffCount={dropOff.pending.count}
//             dropOffPercentage={dropOff.pending.pct}
//           >
//             <div
//               className="customCard secondOne yellowish"
//               style={{ minWidth: 220, textAlign: "center" }}
//             >
//               <h5>New Lead</h5>
//               <h4>{data?.newlead?.count?.toLocaleString()}</h4>
//             </div>
//           </FunnelRow>

//           <VerticalConnector />

//           {/* 3 ── Communicated */}
//           <FunnelRow
//             dropOffLabel="Rejected"
//             dropOffCount={dropOff.newlead.count}
//             dropOffPercentage={dropOff.newlead.pct}
//           >
//             <div
//               className="customCard secondOne bluish"
//               style={{ minWidth: 220, textAlign: "center" }}
//             >
//               <h5>Communicated</h5>
//               <h4>{data?.communicated?.count?.toLocaleString()}</h4>
//             </div>
//           </FunnelRow>

//           <VerticalConnector />

//           {/* 4 ── Loan Under Process — FIRST-LEVEL FILTER */}
//           <Section
//             dropOffLabel="Rejected"
//             labelColor="rgba(116,82,157,1)"
//             bg="rgba(214,215,255,0.38)"
//           >
//             <FunnelRow
//               dropOffLabel="Rejected"
//               dropOffCount={dropOff.communicated.count}
//               dropOffPercentage={dropOff.communicated.pct}
//             >
//               <div
//                 className="customCard secondOne bluish"
//                 style={{ minWidth: 220, textAlign: "center" }}
//               >
//                 <h5>Loan Under Process</h5>
//                 <h4>{data?.loanunderprocess?.count?.toLocaleString()}</h4>
//               </div>
//             </FunnelRow>
//           </Section>

//           <SplitConnector />

//           {/* 5 ── Approved | Rejected | Expired — SECOND-LEVEL FILTER */}
//           <Section
//             dropOffLabel="Rejected"
//             labelColor="rgba(138,42,143,1)"
//             bg="rgba(220,159,255,0.08)"
//           >
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 gap: "3%",
//                 flexWrap: "wrap",
//               }}
//             >
//               <div
//                 className="customCard secondOne bluish"
//                 style={{ minWidth: 200, textAlign: "center" }}
//               >
//                 <h5>Approved</h5>
//                 <h4>{data?.approved?.count?.toLocaleString()}</h4>
//               </div>
//               <div
//                 className="customCard secondOne redish"
//                 style={{ minWidth: 200, textAlign: "center" }}
//               >
//                 <h5>Rejected</h5>
//                 <h4>{data?.rejected?.count?.toLocaleString()}</h4>
//               </div>
//               <div
//                 className="customCard secondOne orangish"
//                 style={{ minWidth: 200, textAlign: "center" }}
//               >
//                 <h5>Expired</h5>
//                 <h4>{data?.expired?.count?.toLocaleString()}</h4>
//               </div>
//             </div>
//           </Section>

//           {/* Approved-only → Disbursed connector */}
//           <ApprovedToDisbursedConnector />

//           {/* 6 ── Disbursed */}
//           <FunnelRow style={{ marginBottom: 36 }}>
//             <div
//               className="customCard thirdOne"
//               style={{ minWidth: 220, textAlign: "center" }}
//             >
//               <h5>Disbursed</h5>
//               <h4>{data?.disbursed?.count?.toLocaleString()}</h4>
//             </div>
//           </FunnelRow>
//         </div>
//       )}
//     </>
//   );
// }


import { useState, useEffect } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getLeadFunnelByDateRange } from "../ActionCreator";
import SpinnerLoader from "../../../../presentationals/Loader/Loader.component";
import moment from "moment";
import DateFilterSelect from "../../../../CustomDatePicker/DateFilterSelect";

const SIDE_W = 240;

// ─── Single side exit card (no connector — connector is external) ──────────────

const ExitCard = ({ label, count, percentage, color = "red" }) => {
  const theme = {
    red: {
      bg: "rgba(255,241,241,0.95)", border: "rgba(239,68,68,0.30)",
      shadow: "rgba(239,68,68,0.08)", label: "rgba(153,27,27,0.75)",
      count: "rgba(185,28,28,1)", sub: "rgba(153,27,27,0.55)",
    },
    orange: {
      bg: "rgba(255,247,237,0.95)", border: "rgba(249,115,22,0.30)",
      shadow: "rgba(249,115,22,0.08)", label: "rgba(154,52,18,0.75)",
      count: "rgba(194,65,12,1)", sub: "rgba(154,52,18,0.55)",
    },
  }[color];

  if (!count || count <= 0) return null;

  return (
    <div style={{
      border: `1.5px solid ${theme.border}`, borderRadius: 10,
      padding: "20px", backgroundColor: theme.bg,
      minWidth: 210, textAlign: "center",
      boxShadow: `0 2px 10px ${theme.shadow}`,
    }}>
      <h5 style={{ fontSize: 10, fontWeight: 400, color: theme.label, letterSpacing: "0.6px", textTransform: "uppercase" }}>
        {label}
      </h5>
      <h4 style={{ margin: "0 0 3px", fontSize: 16, fontWeight: 500, color: theme.count, lineHeight: 1.2 }}>
        {Number(count).toLocaleString()}
      </h4>
 
    </div>
  );
};

// ─── Simple single arrow + card ───────────────────────────────────────────────

const SideExitCard = ({ label, count, percentage, color = "red" }) => {
  if (!count || count <= 0) return null;
  const lineColor = color === "red" ? "rgba(239,68,68,0.40)" : "rgba(249,115,22,0.45)";
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ position: "relative", width: 48, height: 3, backgroundColor: lineColor, flexShrink: 0 }}>
        <div style={{
          position: "absolute", right: -7, top: "50%", transform: "translateY(-50%)",
          borderTop: "5px solid transparent", borderBottom: "5px solid transparent",
          borderLeft: `7px solid ${lineColor}`,
        }} />
      </div>
      <ExitCard label={label} count={count} percentage={percentage} color={color} />
    </div>
  );
};

// ─── BranchingSideExit — proper T-junction connector ─────────────────────────
// Entry line from card → hits vertical stem at midpoint → arrows branch to each card

const BranchingSideExit = ({
  topLabel, topCount, topPct, topColor = "red",
  botLabel, botCount, botPct, botColor = "orange",
}) => {
  if (!topCount && !botCount) return null;

  const CARD_H  = 82;   // matches ExitCard rendered height
  const GAP     = 12;   // gap between cards
  const STEM_X  = 24;   // x position of vertical stem
  const ARROW_W = 40;   // arrow length after stem
  const TOTAL_H = CARD_H * 2 + GAP;
  const SVG_W   = STEM_X + ARROW_W + 8

  const topY = CARD_H / 2;                         // center of top card: 41
  const botY = CARD_H + GAP + CARD_H / 2;          // center of bot card: 135
  const midY = (topY + botY) / 2;                  // entry point = component center: 88

  const STEM   = "rgba(100,116,139,0.40)";
  const RED    = "rgba(239,68,68,0.55)";
  const ORANGE = "rgba(249,115,22,0.60)";

  return (
    <div style={{ display: "flex", alignItems: "flex-start" }}>

      {/* SVG connector — entry from left at midY, stem from topY→botY, two arrows */}
      <svg
        width={SVG_W}
        height={TOTAL_H}
        style={{ flexShrink: 0, overflow: "visible" }}
      >
        {/* ── Entry horizontal line: card right edge → stem, at midY (component center) */}
        <line
          x1={0}      y1={midY}
          x2={STEM_X} y2={midY}
          stroke={STEM} strokeWidth={3} strokeLinecap="round"
        />

        {/* ── Vertical stem: from topY to botY through midY */}
        <line
          x1={STEM_X} y1={topY}
          x2={STEM_X} y2={botY}
          stroke={STEM} strokeWidth={3} strokeLinecap="round"
        />

        {/* ── Top arm: stem → Rejected card center */}
        <line
          x1={STEM_X}      y1={topY}
          x2={SVG_W - 8}   y2={topY}
          stroke={RED} strokeWidth={3} strokeLinecap="round"
        />
        <polygon
          points={`${SVG_W - 8},${topY - 5} ${SVG_W},${topY} ${SVG_W - 8},${topY + 5}`}
          fill={RED}
        />

        {/* ── Bottom arm: stem → Expired card center */}
        <line
          x1={STEM_X}    y1={botY}
          x2={SVG_W - 8} y2={botY}
          stroke={ORANGE} strokeWidth={3} strokeLinecap="round"
        />
        <polygon
          points={`${SVG_W - 8},${botY - 5} ${SVG_W},${botY} ${SVG_W - 8},${botY + 5}`}
          fill={ORANGE}
        />
      </svg>

      {/* Two stacked exit cards */}
      <div style={{ display: "flex", flexDirection: "column", gap: GAP }}>
        <ExitCard label={topLabel} count={topCount} percentage={topPct} color={topColor} />
        <ExitCard label={botLabel} count={botCount} percentage={botPct} color={botColor} />
      </div>
    </div>
  );
};

// ─── Funnel Row ───────────────────────────────────────────────────────────────

const FunnelRow = ({ children, sideContent = null, style = {} }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", ...style }}>
    <div style={{ width: SIDE_W, flexShrink: 0 }} />
    <div style={{ flexShrink: 0 }}>{children}</div>
    <div style={{ width: SIDE_W, flexShrink: 0 }}>
      {sideContent && <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>{sideContent}</div>}
    </div>
  </div>
);

// ─── Vertical Connector ───────────────────────────────────────────────────────

const VerticalConnector = ({ height = 44 }) => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <div style={{ position: "relative", width: 3, height, backgroundColor: "rgba(100,116,139,0.35)" }}>
      <KeyboardArrowDownIcon style={{
        position: "absolute", bottom: -13, left: "50%", transform: "translateX(-50%)",
        color: "rgba(100,116,139,0.5)", fontSize: 24,
      }} />
    </div>
  </div>
);

// ─── Section Wrapper ──────────────────────────────────────────────────────────

const Section = ({ label, labelColor, bg, children }) => (
  <div style={{ background: bg, padding: "28px 0 24px", margin: 0, position: "relative" }}>
    {label && (
      <div className="customSection-tag-box">
        <h5 style={{ color: labelColor, margin: 0 }}>{label}</h5>
      </div>
    )}
    {children}
  </div>
);

const cardBase = { minWidth: 220, textAlign: "center" };

// ─── Main Component ───────────────────────────────────────────────────────────

export default function LeadConversionStat({
  dateFilterPopup, handleDateFilterPopup,
  dateType, setDateType, updateDateRange,
}) {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(false);

  const fetchData = (range) => {
    const sDate = moment(range?.from).format("DD-MM-YYYY");
    const eDate = moment(range?.to).format("DD-MM-YYYY");
    setIsLoading(true);
    getLeadFunnelByDateRange(sDate, eDate, (res) => {
      setIsLoading(false);
      setData(res?.data?.data || {});
    });
  };

  useEffect(() => { fetchData(dateFilterPopup); }, [dateFilterPopup?.from, dateFilterPopup?.to]);

  const handleFilterReset = () => {
    const from = moment().subtract(6, "days").format("YYYY-MM-DD");
    const to   = moment().format("YYYY-MM-DD");
    setIsFilterCleared(true);
    handleDateFilterPopup("from", from);
    handleDateFilterPopup("to", to);
    fetchData({ from, to });
  };

  const { pending, newlead, communicated, loanunderprocess, approved, rejected, expired, disbursed, ongoing } = data || {};

  return (
    <>
      <div className="HeadingFilter-main-filters" style={{ marginTop: 10, padding: "2px 10px 6px" }}>
        <div className="row">
          <div className="col-xl-9 col-lg-10 col-xs-12" style={{ display: "flex", gap: 10, marginTop: 5 }}>
            <DateFilterSelect
              dateFilterPopup={dateFilterPopup}
              onChange={(range) => updateDateRange(range[0], range[1], "custom")}
              isFilterCleared={isFilterCleared}
              type={dateType}
              onTypeChange={setDateType}
            />
          </div>
          <div className="col-xl-3 col-lg-2 col-xs-12" style={{ marginTop: 5 }}>
            <div style={{ display: "flex", gap: 8, justifyContent: window.innerWidth > 1200 ? "flex-end" : "flex-start" }}>
              <div className="custom-btn"><i className="fa fa-download" /></div>
              <div className="custom-btn" onClick={handleFilterReset}><i className="fa fa-times" /></div>
            </div>
          </div>
        </div>
      </div>

      {isLoading ? <SpinnerLoader /> : (
        <div className="customTree" style={{ padding: "30px 0 40px" }}>

          {/* 1 ── Pending Lead */}
          <FunnelRow style={{ marginTop: 8 }}>
            <div className="customCard firstOne" style={cardBase}>
              <h5>Pending Lead</h5>
              <h4>{pending?.count?.toLocaleString()}</h4>
            </div>
          </FunnelRow>

          <VerticalConnector />

          {/* 2 ── New Lead → Rejected */}
          <FunnelRow
            sideContent={
              <SideExitCard
                label="Rejected"
                count={pending?.rejectedAfterStage}
                percentage={pending?.dropOffPercentage}
                color="red"
              />
            }
          >
            <div className="customCard secondOne yellowish" style={cardBase}>
              <h5>New Lead</h5>
              <h4>{newlead?.count?.toLocaleString()}</h4>
            </div>
          </FunnelRow>

          <VerticalConnector />

          {/* 3 ── Communicated → Rejected | FIRST-LEVEL bg */}
          <Section
            label="FIRST‑LEVEL FILTER (POST COMMUNICATION)"
            labelColor="rgba(116,82,157,1)"
            bg="rgba(214,215,255,0.38)"
          >
            <FunnelRow
              sideContent={
                <SideExitCard
                  label="Rejected"
                  count={communicated?.rejectedAfterStage}
                  percentage={communicated?.dropOffPercentage}
                  color="red"
                />
              }
            >
              <div className="customCard secondOne bluish" style={cardBase}>
                <h5>Communicated</h5>
                <h4>{communicated?.count?.toLocaleString()}</h4>
              </div>
            </FunnelRow>
          </Section>

          <VerticalConnector />

          {/* 4 ── LUP → branching Rejected + Expired | SECOND-LEVEL bg */}
          <Section
            label="SECOND‑LEVEL FILTER (POST LUP)"
            labelColor="rgba(138,42,143,1)"
            bg="rgba(220,159,255,0.08)"
          >
            <FunnelRow
              sideContent={
                <BranchingSideExit
                  topLabel="Rejected"
                  topCount={loanunderprocess?.rejectedAfterStage}
                  topPct={loanunderprocess?.dropOffPercentage}
                  topColor="red"
                  botLabel="Expired"
                  botCount={expired?.count}
                  botPct={expired?.dropOffPercentage}
                  botColor="orange"
                />
              }
            >
              <div className="customCard secondOne bluish" style={cardBase}>
                <h5>Loan Under Process</h5>
                <h4>{loanunderprocess?.count?.toLocaleString()}</h4>
              </div>
            </FunnelRow>
          </Section>

          <VerticalConnector />

          {/* 5 ── Approved — no exit | POST-APPROVAL bg */}
          <Section
            label="POST‑APPROVAL (OPS STAGE)"
            labelColor="rgba(50,126,69,1)"
            bg="rgba(52,170,56,0.08)"
          >
            <FunnelRow>
              <div className="customCard secondOne bluish" style={cardBase}>
                <h5>Approved</h5>
                <h4>{approved?.count?.toLocaleString()}</h4>
              </div>
            </FunnelRow>
          </Section>

          <VerticalConnector />

          {/* 6 ── Disbursed */}
          <FunnelRow>
            <div className="customCard thirdOne" style={cardBase}>
              <h5>Disbursed</h5>
              <h4>{disbursed?.count?.toLocaleString()}</h4>
            </div>
          </FunnelRow>

          <VerticalConnector />

          {/* 7 ── Ongoing */}
          <FunnelRow style={{ marginBottom: 36 }}>
            <div className="customCard secondOne" style={{
              ...cardBase,
              border: "2px solid rgba(100,116,139,0.25)",
              backgroundColor: "rgba(248,250,252,0.85)",
            }}>
              <h5>Ongoing</h5>
              <h4>{ongoing?.count?.toLocaleString()}</h4>
            </div>
          </FunnelRow>

        </div>
      )}
    </>
  );
}